import { Box, Typography } from '@mui/material';
import { tokenSupplyStatusList, TokenSupplyStatusType, triTokenSupplyStatusList } from './list';
import { TOKEN_SFL } from '../../../lib/name-space';

export function TokenSupplyStatusDataName({ type }: { type: string }) {
  const dataList: TokenSupplyStatusType[] = type === TOKEN_SFL ? tokenSupplyStatusList : triTokenSupplyStatusList;
  return (
    <>
      {dataList.map((data: TokenSupplyStatusType) => (
        <Box
          key={data.label}
          sx={{
            width: data.chartData.width,
            height: '20px',
            background: data.chartData.color,
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              color: '#333333',
              textAlign: 'right',
              mr: '12.1px',
              ml: '3px',
            }}
          >
            {data.chartData.percent}
          </Typography>
        </Box>
      ))}
    </>
  );
}

export function TokenSupplyStatusDataGraph({ type }: { type: string }) {
  const dataList: TokenSupplyStatusType[] = type === TOKEN_SFL ? tokenSupplyStatusList : triTokenSupplyStatusList;
  return (
    <>
      {dataList.map((data: TokenSupplyStatusType) => (
        <Box key={data.label} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Box
            sx={{
              background: data.chartData.color,
              width: '6px',
              height: '6px',
            }}
          />
          <Typography
            sx={{
              fontSize: '11px',
              lineHeight: '13px',
              letterSpacing: '-0.02em',
              color: '#333333',
            }}
          >
            {data.label}
          </Typography>
          <Typography
            sx={{
              ml: 'auto',
              fontSize: '11px',
              lineHeight: '13px',
              letterSpacing: '-0.02em',
              color: '#333333',
            }}
          >
            {data.shuffle} {type}
          </Typography>
        </Box>
      ))}
    </>
  );
}

export function TokenSupplyStatusDataAmount({ type }: { type: string }) {
  const dataList: TokenSupplyStatusType[] = type === TOKEN_SFL ? tokenSupplyStatusList : triTokenSupplyStatusList;
  return (
    <>
      {dataList.map((data) => (
        <Box key={data.label} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <Box
            sx={{
              background: data.chartData.color,
              width: '6px',
              height: '6px',
            }}
          />
          <Typography
            sx={{
              fontSize: '11px',
              lineHeight: '13px',
              letterSpacing: '-0.02em',
              color: '#333333',
            }}
          >
            {data.label}
          </Typography>
          <Typography
            sx={{
              ml: 'auto',
              fontSize: '11px',
              lineHeight: '13px',
              letterSpacing: '-0.02em',
              color: '#333333',
            }}
          >
            {data.shuffle} {type}
          </Typography>
        </Box>
      ))}
    </>
  );
}
